import React, { ReactNode } from 'react';
import { requestPayout, reviewInsurerPayout } from '../../../../../api/requests';
import Button from '../../../../../components/form-control/Button';
import { Payout } from '../../../../../models/payout/Payout';
import { PAYOUT_REVIEW_STATES, COMPANY_TYPES } from '../../../../../resources/enums';
import { formatCurrencyAmount, showToast } from '../../../../../utils/miscFunctions';
import { IRequestResponse } from '../../../../../resources/interfaces';

interface IPayoutReviewProps {
  payout: Payout;
  onProceed: () => void;
  onCancel: () => void;
  type: PAYOUT_REVIEW_STATES;
  title: string;
  titleIcon?: ReactNode | JSX.Element;
}

const PayoutReview = (props: IPayoutReviewProps) => {
  const [submitting, setSubmitting] = React.useState<boolean>(false);

  const handleSubmit = () => {
    setSubmitting(true);

    if (
      props.type === PAYOUT_REVIEW_STATES.REQUEST &&
      props.payout.broker?.type === COMPANY_TYPES.AGENCY
    ) {
      requestPayout(props.payout.broker?.id ?? '', props.payout.id)
        .then((response: any) => {
          props.onProceed();
          showToast.success(response?.message ?? 'Payout requested successfully');
          props.onProceed();
        })
        .catch((error: IRequestResponse) => {
          showToast.error(error?.description);
        })
        .finally(() => setSubmitting(false));
    }

    if (
      props.type === PAYOUT_REVIEW_STATES.REQUEST &&
      (props.payout.broker?.type === COMPANY_TYPES.INSURER || props.payout.broker?.type === COMPANY_TYPES.BROKER)
    ) {
      reviewInsurerPayout(props.payout.broker?.id ?? '', props.payout.id)
        .then((response: any) => {
          props.onProceed();
          showToast.success(response?.message ?? 'Payout reviewed successfully');
          props.onProceed();
        })
        .catch((error: IRequestResponse) => {
          showToast.error(error?.description);
        })
        .finally(() => setSubmitting(false));

    }


  };

  const getDescription = (): string => {
    switch (props.type) {
      case PAYOUT_REVIEW_STATES.REQUEST:
        return 'By requesting payout, you agree that commissions, rates and sum amount is right.';

      case PAYOUT_REVIEW_STATES.PAID:
        return 'By marking this payout as paid, you confirm that payment has been made to the respective agency.';

      case PAYOUT_REVIEW_STATES.APPROVE:
        return 'By approving this payout, you confirm that commissions, rates and sum amount is right.';

      default:
        return '';
    }
  };

  return (
    <div className="bg-white rounded-xl">
      <div className="p-4">
        <div className="py-2 space-y-4">
          <p>{getDescription()}</p>
        </div>


        <div className="py-2 space-y-4 mb-6">
          <div className="grid grid-cols-2 items-center gap-5">
            <p className='font-semibold'>Amount: </p>
            <p className='text-gray-500'>{props?.payout?.currency } {" "}{formatCurrencyAmount(props?.payout?.grossToPay)}</p>
          </div>
        </div>

         <div className="w-full flex gap-4 ">
          <Button
            label="Cancel"
            bgColor='secondary'
                  fullWidth
            onClick={props.onCancel}
          />
           <Button
            label="Confirm"
            onClick={handleSubmit}
            bgColor='primary'
              fullWidth
            loading={submitting}
            disabled={submitting}
          />
        </div>
      </div>
    </div>
  );
};

export default PayoutReview;
